import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=8c22f880&"
import script from "./BaseNotification.vue?vue&type=script&lang=js&"
export * from "./BaseNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports